export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'English'
  },
  'title': 'PRODUCT RECALL QUICKDRAWS ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Product Recall. Important information regarding your safety and equipment.',
    'purchaseWindow': 'You purchased an ALPINISM and/or VERTIKA climbing quickdraw between January 1, 2022, and July 23, 2026.',
    'skus': 'Alpinism 11 cm Quickdraw (4051175 / 8589547)\nAlpinism 17 cm Quickdraw (4051176 / 8589548)\nPack of 5 Alpinism Quickdraws (4171656 / 8608405)\nVertika 11 cm Quickdraw (5499689 / 8935765)\nVertika 17 cm Quickdraw (5500194 / 8935909)',
    'responsibility': 'Designing personal protective equipment implies absolute responsibility towards those who use our products. Therefore, we are informing you of a recall concerning the quickdraw equipped with the Rocky Fil carabiner.',
    'defect': 'We have identified a defect in the riveting of the wire gate on some carabiners. This assembly defect can cause the wire gate to break and create a risk of the carabiner breaking in the event of a fall. fall.',
    'stopUsing': 'As a precaution, we ask that you immediately stop using your product and follow the procedure below.'
  },
  'procedure': {
    'stopUsing': 'We therefore ask you to immediately cease using this equipment and check if your product is affected by this defect using the troubleshooting instructions below.',
    'title': 'Check your products:',
    'intro': 'Check that both sides of the wire gate remain securely attached to the carabiner:',
    'step1': 'Take the carabiner on one side, place your thumb between the two wires (thumb closest to the rivet). Press firmly downwards against the carabiner.',
    'step2': 'Turn the carabiner over and repeat the same action on the other side of the wire gate.'
  },
  'outcome': {
    'nok': {
      'body': 'After inspection, the wire has come loose: Please stop using your product immediately and return it to your nearest DECATHLON store. Our team will take care of your defective product and process a full refund immediately for these recalled items.',
      'support': 'If you have a specific situation, our customer service team is available to find a tailored solution and guide you every step of the way: Monday to Friday: 9am - 8pm Saturday: 9am - 6pm Sunday: 9am - 6pm +44 7976 630897'
    },
    'ok': {
      'body': 'After checking, the wire does not come out of its housing: Your product is not affected by this defect, you can continue to use it with complete peace of mind.'
    }
  },
  'buttons': {
    'ok': 'My product is OK',
    'nok': 'My product is Not OK'
  }
} as const
